import React from 'react';
import Navbar from '../../components/Navbar2';
import Contact from '../../components/Contact';
import { Link } from 'react-router-dom';
import './index.css';

const AboutMembershipPage = () => {
  return (
    <div className="si-page">
      <Navbar />

      {/* Hero Section */}
      <div className="si-hero">
        <div className="si-hero-overlay" />
        <div className="si-hero-content">
          <p className="si-hero-label">By Invitation Only</p>
          <h1 className="si-hero-title">Become a Member</h1>
          <p className="si-hero-sub">
            Not all journeys are meant to be shared. Some are reserved for those who seek a certain way of experiencing the world. Luxe Unbounded Membership is a private circle — offering access to exceptional homes, without the responsibility of ownership.
          </p>
        </div>
      </div>

      {/* Intro Section */}
      <div className="si-intro-section">
        <div className="si-intro-inner">
          <p className="si-label">An Invitation, Not an Offering</p>
          <h2 className="si-title">A Circle Reserved for the Few</h2>
          <p className="si-text">
            This is not a membership for everyone. It is a carefully extended invitation to individuals who value quiet luxury, meaningful travel, and a sense of belonging across places they return to. A circle where access is limited — and experiences remain deeply personal.
          </p>
        </div>
      </div>

      {/* Content Sections */}
      <div className="si-sections-wrap">
        {/* Section 1 - Access Without Ownership */}
        <div className="si-hs-section">
          <div className="si-hs-text">
            <p className="si-hs-label">Access</p>
            <h2 className="si-hs-title">Access Without Ownership</h2>
            <p className="si-hs-desc">
              Enjoy privileged stays across the Luxe Unbounded collection — including both our owned residences and a curated portfolio of partner homes. Designed for those who seek the experience of ownership, without the commitment of it.
            </p>
            <ul className="si-list">
              <li>Up to 5 nights annually across our portfolio, thoughtfully reserved for a family of four</li>
              <li>Access to Luxe Unbounded homes and select partner residences</li>
              <li>Stays included; bespoke services are offered as per usage</li>
              <li>Reservations planned in advance, subject to availability</li>
            </ul>
          </div>
          <div className="si-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fshared.webp?alt=media&token=e125deba-2d83-4a2f-ad51-da0862c210e6"
              alt="Luxury Villa"
            />
          </div>
        </div>

        {/* Section 2 - A Private Circle */}
        <div className="si-hs-section si-hs-section-reversed">
          <div className="si-hs-text">
            <p className="si-hs-label">Exclusivity</p>
            <h2 className="si-hs-title">A Private Circle</h2>
            <p className="si-hs-desc">
              Membership is intentionally limited to preserve its character.
            </p>
            <ul className="si-list">
              <li>Only 20 members will be extended membership in the inaugural year</li>
              <li>Each request is reviewed through a quiet process of consideration</li>
              <li>A like-minded community that values discretion, space, and refined living</li>
            </ul>
          </div>
          <div className="si-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fhomes-for-all-seasons.webp?alt=media&token=1a9cc5ed-d15e-4c55-b8c0-32b872715fcc"
              alt="Private Circle"
            />
          </div>
        </div>

        {/* Section 3 - Eligibility */}
        <div className="si-hs-section">
          <div className="si-hs-text">
            <p className="si-hs-label">Eligibility</p>
            <h2 className="si-hs-title">A Note on Eligibility</h2>
            <p className="si-hs-desc">
              Membership is thoughtfully extended to individuals whose lifestyle and financial standing align with the ethos of Luxe Unbounded. As a guiding benchmark:
            </p>
            <ul className="si-list">
              <li>Working professionals with an annual income of INR 50 Lakhs and above</li>
              <li>Entrepreneurs and business owners with an annual turnover of INR 30 Crores and above</li>
            </ul>
            <p className="si-hs-note">This ensures the experience remains uncompromised — and the circle, truly exceptional.</p>
          </div>
          <div className="si-hs-image">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2Fvilla4.webp?alt=media&token=5430db51-b6cb-478b-af6e-83128d06bd75"
              alt="Eligibility"
            />
          </div>
        </div>
      </div>

      {/* Closing Section */}
      <div className="si-closing-section" id="consideration">
        <div className="si-closing-inner">
          <p className="si-label">If this speaks to you</p>
          <h2 className="si-closing-title">You may already belong here.</h2>
          <Link to="/invitation-form" className="si-submit-btn">
            Seek Invitation
          </Link>
        </div>
      </div>

      <Contact />
    </div>
  );
};

export default AboutMembershipPage;
